export default "__VITE_ASSET__679096d2__"